import * as apiClients from './clients/index.js';

/**
 * Get the auto-generated API client configs.
 *
 * Primarily here rather than using a direct import elsewhere for mocking purposes.
 */
export const getClients = () => apiClients;